export class OrganizationConstantValue {
  value: string;
  startTimestamp: number;
  endTimestamp: number;

  constructor() {
    this.value = '';
    this.startTimestamp = new Date().getTime();
    this.endTimestamp = new Date().getTime();
  }
}